<div class="modal-wrapper">
  <div cf-modal-header [hideCloseButton]="true" [heading]="'settings.timezone.changed' | translate"></div>

  <div class="modal-body">
    <cf-text>
      <span
        [innerHTML]="
          'settings.timezone.computer_changed'
            | translate: { timezoneName: (accountService.localTimezone | timezoneName) || '' }
        "
      ></span>
    </cf-text>
  </div>

  <div class="modal-footer">
    <cf-button (click)="activeModal.dismiss()" color="secondary">
      {{ "settings.timezone.no_update" | translate }}
    </cf-button>
    <cf-button (click)="activeModal.close()"> {{ "settings.timezone.yes_update" | translate }} </cf-button>
  </div>
</div>
